module.exports = __webpack_public_path__ + "img/017-blockchain-1.1ed8202f.png";